import React from "react";
import styles from "./styles.module.scss";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import { Trans, useTranslation } from "react-i18next";
import NotifyStudentsToggle from "./EventForm/NotifyStudentsToggle";
import { showsNotifyStudents } from "./hooks/notifyStudents";

const CustomRefundModal = ({ actions, data, loading, options = null, setOptions = null }) => {
    const { t } = useTranslation();
    const { title, content, event } = data;
    const buttonStyle = styles.btn_confirm;

    const checkContent = (content: string) => {
      if (content === "refund_athlete_was_billed_online") {
        return (
          <Trans
            i18nKey="refund_athlete_was_billed_online"
            values={{ amount: event.rate, symbol: event.coachProfile?.currencySymbol }}
            components={{ strong: <strong /> }}
          />
        );
      }

      return content || t("Are you sure you want to proceed with this action?");
    };

    return (
        <ModalLayout isOpen classNames={styles.modal}>
            <div className={styles.confirmation_modal_content}>
                <div className={styles.close_button} onClick={actions.onCancel}>
                    <i className="ico ico-x" />
                </div>

                <div className={styles.title}>
                    <i className={`ico ico-dollar ${styles.dollar_icon}`} />
                    <h2>{title || t("Confirm the refund")}</h2>
                </div>

                <div className={styles.content}>
                    {checkContent(content)}
                </div>

                {setOptions && showsNotifyStudents(data) && (
                    <NotifyStudentsToggle
                        checked={options?.notifyStudents ?? true}
                        onChange={(notifyStudents) => setOptions({ notifyStudents })}
                    />
                )}

                <div className={styles.actions}>
                    <button type="button" className={`btn ${buttonStyle}`} onClick={actions.onConfirm} disabled={loading}>
                        {loading ? (
                            <span className={styles.spinner} />
                        ) : (
                            t("Refund this Session")
                        )}
                    </button>
                    <button type="button" className={`btn ${styles.cancel_button}`}
                    onClick={actions.onChargeLateCancellation} disabled={loading}>
                        {t("Charge for Late Cancellation")}
                    </button>
                </div>
            </div>
        </ModalLayout>
    );
};

export default CustomRefundModal;
